import React from "react";

import Toggle from "../../scripts/modules/Toggle";
import Button from "../../components/Button";

export default class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
    this.trigger = React.createRef();
  }

  componentDidMount() {
    this.instance = new Toggle(this.trigger.current);
  }

  componentWillUnmount() {
    this.instance.destroy();
  }

  render() {
    const { children, ...other } = this.props;
    return (
      <Button elemRef={this.trigger} {...other}>
        {children}
      </Button>
    );
  }
}
